/**
 * Determines if an argument is defined based on
 * null or undefined values.
 *
 * @param {any} value - The value to be checked.
 * @returns {boolean} - True if the value is defined, false otherwise.
 */
export function isDefined(value) {
  return value !== null && value !== undefined
}
